import styled from 'styled-components';
import { device, color, Common } from '@stockbit/ui';
import { assetPrefix } from 'constants/app';

const { Flex, Text } = Common;

export const KomisiList = styled(Flex)`
  position: relative;
  padding: 50px;
  background: url(${assetPrefix}/images/mulai-investasi/table-price-left.svg) no-repeat top
      left,
    url(${assetPrefix}/images/mulai-investasi/table-price-right.svg) no-repeat bottom right;
  background-size: 50px, 50px;

  > div {
    width: 50%;
  }

  @media ${device.tablet} {
    padding: 100px;
    background-size: 100px, 100px;
  }
`;

export const KomisiContainer = styled.div`
  margin: auto;
  width: 100%;
  @media ${device.laptopL} {
    width: 70%;
  }
`;

export const KomisiNumber = styled(Text).attrs({
  align: 'center',
  family: 'bold',
  color: color.primary,
})`
  font-size: 36px;
  @media ${device.tablet} {
    font-size: 50px;
  }
  @media ${device.laptop} {
    font-size: 80px;
  }
`;

export const KomisiTitle = styled(Text).attrs({
  align: 'center',
})`
  font-size: 20px;
  @media ${device.tablet} {
    font-size: 24px;
  }
`;
